function isObject(data) {
    return typeof data === "object" && data !== null;
  }

  const shopMetadata = {
    get() {
      try {
        const shop_metadata = JSON.parse(
          localStorage.getItem("shop_metadata")
        );
        if (!isObject(shop_metadata)) {
          return {
            id:           0,
            name:         "",
            owner_name:   "",
            postcode:     "",
            payment_type: "",
            status_shop:  "",
            created_at:   "",
            walletv2_launched_date: "",
          };
        }

        return {
          id:           shop_metadata.id,
          name:         shop_metadata.name,
          owner_name:   shop_metadata.owner_name,
          postcode:     shop_metadata.podtcode,
          payment_type: shop_metadata.payment_type,
          status_shop:  shop_metadata.status_shop,
          created_at:   shop_metadata.created_at,
          walletv2_launched_date: shop_metadata.walletv2_launched_date
        };
      } catch (err) {
        return {
          id:           0,
          name:         "",
          owner_name:   "",
          postcode:     "",
          payment_type: "",
          status_shop:  "",
          created_at:   "",
          walletv2_launched_date: "",
        };
      }
    },
  };

  export default shopMetadata;
